import {Component} from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '@services/app.service';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss']
})
export class ProfileComponent {
    public user;

    constructor(
        private router: Router,
        public appService: AppService
    ) {}

    ngOnInit() {
        this.user = this.appService.user;
    }
}
